module.exports = "/_next/static/images/8c26f85bb3bdca8b42b8e6bcb903e879-belinda-hero-mobile.jpg";